module.exports = __webpack_public_path__ + "fonts/SFUIText-BoldItalic.607a46ee.woff2";